export const FETCH_REPOS_REQUEST = 'FETCH_REPOS_REQUEST';
export const FETCH_REPOS_SUCCESS = 'FETCH_REPOS_SUCCESS';

export const FETCH_REPO_REQUEST = 'FETCH_REPO_REQUEST';
export const FETCH_REPO_SUCCESS = 'FETCH_REPO_SUCCESS';

export const FETCH_LANGUAGES_REQUEST = 'FETCH_LANGUAGES_REQUEST';
export const FETCH_LANGUAGES_SUCCESS = 'FETCH_LANGUAGES_SUCCESS';

export const FETCH_CONTRIBUTORS_REQUEST = 'FETCH_CONTRIBUTORS_REQUEST';
export const FETCH_CONTRIBUTORS_SUCCESS = 'FETCH_CONTRIBUTORS_SUCCESS';

export const FETCH_FAILURE = 'FETCH_FAILURE';
